import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ExpenseLibraryTemplatesIndexTable from './ExpenseLIbraryTemplatesIndexTable';

function ExpenseLibraryTemplatesIndex() {
    return (
        <ExpenseLibraryTemplatesIndexTable
            templatesIndexUrl={templatesIndexUrl}
            templatesCreateUrl={templatesCreateUrl}
            templatesStoreUrl={templatesStoreUrl}
            templatesShowUrl={templatesShowUrl}
            templatesUpdateUrl={templatesUpdateUrl}
            templatesDeleteUrl={templatesDeleteUrl}
            templatesExportUrl={templatesExportUrl}
        />
    );
}

export default ExpenseLibraryTemplatesIndex;
if (document.getElementById('ExpenseLibraryTemplatesIndex')) {
    var rootEl = document.getElementById('ExpenseLibraryTemplatesIndex');
    ReactDOM.render(
        <App>
            <ExpenseLibraryTemplatesIndex />
        </App>,
        rootEl,
    );
}
